				module.controller(
    'regulationListCtrl',
    [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService', 
        function($scope, $rootScope, $state, regulationService, alertService) {

            $scope.filter = {
                visible: true,
                type: null 
            };
            $scope.regulations = [];
            $scope.pagination = {
                current : 1,
                total : 0
            };

            /**
             *
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;

                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                if($scope.filter.type){
                    filter.typeName = $scope.filter.type;
                }

                regulationService.searchRegulations(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();

                    $scope.regulations = result.results;
                    $scope.pagination.total = result.totalRegisters;

                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.remove= function(idRegulation){
            	var reg = $scope.regulations.find(function(reg){ return reg.id == idRegulation; })
                alertService.showSwtQuestion('Eliminar normativa "'+ reg.name +'"', function() {
                    $scope.loading = true;

                    regulationService.removeRegulation(idRegulation).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Normativa eliminada satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            }
            
            /**
             *
             */
            $scope.clearFilters = function(){
                $scope.filter = {};
            };

            $scope.search(1);
            
            $scope.changeRegulationState = function(idRegulation, state){
            	if(state){
            		regulationService.enableRegulation(idRegulation).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess(REGULATION_ACTIVE);
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            	else{
            		regulationService.disableRegulation(idRegulation).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess(REGULATION_INACTIVE);
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            };

        } ]);
